import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, connect } from 'react-redux';
import { getHelptexts } from '../store/profile/profile.selectors';

const Helptext = ({ name, render, ...props }) => {
  const helptexts = useSelector(getHelptexts);
  if (render) {
    return (
      <>
        {(helptexts
          && helptexts.helptexts
          && render(helptexts.helptexts[name]))
          || null}
      </>
    );
  }
  return (
    <div {...props}>
      {(helptexts && helptexts.helptexts && helptexts.helptexts[name]) || null}
    </div>
  );
};

Helptext.propTypes = {
  name: PropTypes.string.isRequired,
  render: PropTypes.func,
};

Helptext.defaultProps = {
  render: null,
};

export default connect()(Helptext);
